export default (width = 18, height = 17, color = '#3C3C3C') => `
<svg width="${width}" height="${height}" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.7 9.35l-1 1-2.05-2.05 1-1a.55.55 0 01.77 0l1.28 1.28c.21.21.21.56 0 .77zM8 14.94l6.06-6.06 2.05 2.05L10.06 17H8v-2.06zM8 10c-4.42 0-8 1.79-8 4v2h6v-1.89l4-4c-.66-.08-1.33-.11-2-.11zM8 0a4 4 0 100 8 4 4 0 000-8z" fill="${color}"/>
</svg>
`
